import React from 'react';
import { FiClock, FiShield, FiUsers, FiMessageSquare } from 'react-icons/fi';

const items = [
  {
    icon: <FiClock className="h-5 w-5" />,
    title: '24/7 availability',
    text: 'Request support any time through our service desk.',
  },
  {
    icon: <FiShield className="h-5 w-5" />,
    title: 'Secure handling',
    text: 'Your request details are processed through a protected flow.',
  },
  {
    icon: <FiUsers className="h-5 w-5" />,
    title: 'Partner-trained agents',
    text: 'Experienced teams handle subscription and billing questions.',
  },
  {
    icon: <FiMessageSquare className="h-5 w-5" />,
    title: 'Clear communication',
    text: 'Straightforward answers, quick follow-up, and guided next steps.',
  },
];

export default function TrustBar() {
  return (
    <section className="px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="rounded-[1.8rem] border border-[#dbe8f5] bg-white/80 p-5 shadow-[0_30px_80px_-55px_rgba(13,27,42,0.8)] sm:p-6">
          <div className="grid gap-4 sm:grid-cols-2 md:grid-cols-4">
          {items.map(item => (
              <div key={item.title} className="rounded-2xl border border-[#dbe8f5] bg-white p-4 transition-all hover:-translate-y-1 hover:shadow-[0_28px_46px_-34px_rgba(13,27,42,0.6)]">
                <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl bg-[#e9f2fb] text-[#2b6cb0]">{item.icon}</div>
                <h3 className="text-sm font-semibold text-[var(--brand-ink)]">{item.title}</h3>
                <p className="mt-1 text-sm text-[var(--text-muted)]">{item.text}</p>
              </div>
          ))}
          </div>
        </div>
      </div>
    </section>
  );
}